export default class GetAllSubtiposConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllSubtiposConvocatoria()
      return result
    } catch (error) {
      console.error('Error al obtener los subtipos de convocatoria:', error)
      throw error
    }
  }
}
